import { MediaQuery } from '@repo-level/core-front';

export const useMedia = () => {
  const isDesktopXL = window.matchMedia(MediaQuery.DESKTOP_XL).matches;
  const isDesktopL = window.matchMedia(MediaQuery.DESKTOP_L).matches;
  const isDesktop = window.matchMedia(MediaQuery.DESKTOP).matches;
  const isTablet = window.matchMedia(MediaQuery.TABLET).matches;
  const isMobile =
    window.matchMedia(MediaQuery.MOBILE).matches ||
    window.matchMedia(MediaQuery.MOBILE_S).matches;
  const isMobileS = window.matchMedia(MediaQuery.MOBILE_S).matches;

  return {
    isDesktopXL,
    isDesktopL,
    isDesktop,
    isTablet,
    isMobile,
    isMobileS,
  };
};
